import React from "react";
import { Button, type ButtonProps } from "@chakra-ui/react";

type FilterButtonProps = ButtonProps & {
  isActive: boolean;
};

export function FilterButton({ isActive, children, ...props }: FilterButtonProps) {
  return (
    <Button
      variant="unstyled"
      color={isActive ? "brand.text.light" : "brand.textSecondary.light"}
      fontSize="brand.sm"
      fontWeight="semibold"
      textDecoration={isActive ? "underline" : "none"}
      textUnderlineOffset={3}
      transition="color .15s ease-in-out"
      _hover={{ color: isActive ? undefined : "brand.text.light" }}
      {...props}
    >
      {children}
    </Button>
  );
}
